import {envConfig} from 'config';

// TODO: replace API_URL with envConfig.apiUrl in the whole app
export const API_URL = envConfig.apiUrl;